






































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiAvatar from "@/components/common/AsiAvatar.vue";

@Component({
	components: {AsiAvatar}
})
export default class AsiCardDetailEntry extends Vue {

	@Prop({type: String, default: null})
	public icon!: string | null;

	@Prop({type: String, default: 'grey'})
	public iconColor!: string | null;

	@Prop({type: String, default: 'transparent'})
	public iconBgColor!: string | null;

	@Prop({type: String, default: null})
	public imageUrl!: string | null;

	@Prop({type: String, default: null})
	public label!: string | null;

	@Prop({default: null})
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public value!: any;

	@Prop({type: Boolean, default: false})
	public hideIfEmpty!: boolean;

	@Prop({type: Boolean, default: false})
	public multiline!: boolean;

	private get finalIcon(): string {
		return this.icon === null ? Icon.list : this.icon;
	}

	private get finalLabel(): string | null {
		return this.label;
	}

	private get finalValue(): string | string[] | null {
		if (this.value === null || this.value === undefined) {
			return '-';
		} else if (Array.isArray(this.value) && this.value.length === 0) {
			return '-';
		} else if (typeof this.value === 'boolean') {
			return this.$t(this.value ? 'ui.yes' : 'ui.no').toString();
		} else if (typeof this.value === 'string' && this.multiline) {
			return this.value.split(/\r\n|\n|\r/);
		}

		return this.value;
	}

	private get finalValueIsArray(): boolean {
		return Array.isArray(this.finalValue);
	}

	private get hasContent(): boolean {
		return !!this.$slots.default;
	}

}
